import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { AuthLayout } from '../../../components/Layout/AuthLayout';
import TranslatingContainer from '../../../components/TranslatingContainer/TranslatingContainer';
import TranslatingContainerProvider, { TranslatingContainerContext } from '../../../components/TranslatingContainer/TranslatingContainerProvider';
import SignUpBasicInfoForm from './SignUpBasicInfoForm';
import SignUpMoreInfoForm from './SignUpMoreInfoForm';
import SignUpOptionsForm from './SignUpOptionsForm';
import SignUpPasswordForm from './SignUpPasswordForm';
import SignUpWrapper from './SignUpWrapper';

const SignupHeaderData: Record<number, { title: string; description: string }> =
  {
    0: {
      title: 'Get Started on Logirate',
      description: 'Create an account',
    },
    1: {
      title: 'User Information',
      description: 'Your role helps us personalize your account',
    },
    2: {
      title: 'Tell us how you operate ',
      description: 'Provide more operation information',
    },
    3: {
      title: 'Create a password',
      description: "Keep your account secure, we'll handle the rest.",
    },
  };

const SignUpInner = () => {
  const { sliderIndex } = useContext(TranslatingContainerContext)!;
  const currentSliderIndex = Math.max(0, Math.min(sliderIndex, 3));
  const headerData =
    SignupHeaderData[currentSliderIndex] || SignupHeaderData[0];

  return (
    <AuthLayout
      label='Already have an account?'
      linkTitle='Sign in'
      linkPath='/account/signin'
    >
      <SignUpWrapper
        formHeaderTitle={headerData.title}
        formHeaderDescription={headerData.description}
      >
        <FormContainer>
          <TranslatingContainer>
            <SignUpBasicInfoForm />
            <SignUpOptionsForm />
            <SignUpMoreInfoForm />
            <SignUpPasswordForm />
          </TranslatingContainer>
        </FormContainer>
      </SignUpWrapper>
    </AuthLayout>
  );
};

const SignUp = () => {
  return (
    <TranslatingContainerProvider>
      <SignUpInner />
    </TranslatingContainerProvider>
  );
};

export default SignUp;

const FormContainer = styled.div`
  display: flex;
  overflow: hidden;

  @media (max-width: 884px) {
    width: 100%;
  }
`;
